<ng-container *ngIf="firstWindow == 'send-email'; else validationCodeOtpTmpl">
    <ng-container *ngTemplateOutlet="
    content;
    context: {

    }
  ">
    </ng-container>
</ng-container>

<ng-template #content>
    <ba-get-code-otp-step [isClient]="isClient" (stepDone)="onValidationCodeOtpStepDone($event)"></ba-get-code-otp-step>
</ng-template>

<ng-template #validationCodeOtpTmpl>
    <ba-validation-code-otp-step [ruc]="ruc" [isClient]="isClient" *ngIf="!showViewOtpError && !showViewLockOtp"
        [emailSelectedOtp]="emailSelectedOtp" [numberOfAttemptsOtpCode]="numberOfAttemptsOtpCode"
        (stepDone)="onConfigurationStepDone($event)"></ba-validation-code-otp-step>
    <ba-view-otp-error *ngIf="showViewOtpError" [numberOfAttemptsOtpCode]="numberOfAttemptsOtpCode"
        (onShowValidationCodeOtp)="onShowValidationCodeOtp($event)"></ba-view-otp-error>
    <ba-view-lock-otp *ngIf="showViewLockOtp" (exitFlowCreateAccount)="exitFlowCreateAccount.emit()"></ba-view-lock-otp>
</ng-template>